import React from 'react';

export const Layout = React.lazy(() => import('containers/Home/Layout'));
export const Viewer = React.lazy(() => import('containers/Viewer'));
export const SignIn = React.lazy(() => import('containers/Auth/SingIn'));
// export const SignIn = React.lazy(() => import('containers/Auth/SignIn'));
// export const NotFound = React.lazy(() => import('components/NotFound/NotFound'));
